export function getSportTypeIconUrl(sport: {
  icon_png_url?: string
  icon_svg_url?: string
}): string | undefined {
  return sport.icon_png_url?.trim() || undefined
}
